<template>
    <div>
        
        <div class="main">
            <div class="wrapper">
                <div class=" body-box box-1 mt10 mb10 p10 bg-white text-center">

                    <img src="@/assets/isolir.png" class="mb10" alt="" style="height:100px">

                    <span class="block mb5 f17"><strong>OOPS!!</strong></span>
                    <span class="block mb20 f15"><strong>Internet Anda Sedang Terisolir.</strong></span>

                    
                    <span class="block mb10 f15">Kami informasikan bahwa layanan internet Anda saat ini terisolir atau dimatikan sementara.</span>

                    <span class="block mb10 f15">Pastikan anda telah melakukan pembayaran Tagihan Internet anda.</span>

                    <span  v-show="false" class="block f17 mb20"><strong>"{{get.data.nama}}"</strong></span>

                    <span class="block mb20 f15">Terima Kasih,</span>


                    <span v-show="false" class="block mb10 f15">Anda dapat melakukan pembayaran secara Online</span>
                    

                    <button v-show="false" class="btn btn-info w100 mb10" @click="get.data.afterKlik = false;met.bayar()">Bayar Sekarang</button>

                </div>
            </div>
        </div>


    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    components: { 
        'Loading': Loading
    },
    setup() {
        const get = {
            data: reactive({
                owid: null,
                nama: null
            })
        }
        const met = {
            back() {
                window.history.back();
            },
            bayar() {
                router.push({ 
                    name: 'login'
                });
            },
            owner() {
                //console.log(get.data.uid);

                var datax = {
                    uid: get.data.owid
                };
            
                var apiUrl = inter.IsolirOwner(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    console.log(JSON.stringify(x));

                    if (x.status) {
                        get.data.nama = x.data.nama
                    } else { 
                        alert("Tidak ada Data")
                    }
                })
            }
        }

        return {
            met,
            get,
            myGlobal
        }

    },
    mounted () {        
        
        document.title = "Terisolir!";

        //this.redirectx.checkApp();

        //console.log(this.$route.params.ow);

        this.get.data.owid = this.$route.params.ow;
        
        this.met.owner();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Isolir/main.vue